import type { Dispatch, SetStateAction } from "react";
import Button from "../../../shared/components/Button";
import { siteTexts } from "../../../shared/i18n/siteTexts";
import type { ContentTab } from "../types/admin";

type AdminContentToolbarProps = {
  contentTab: ContentTab;
  onSave: () => Promise<void>;
  saving: boolean;
  setContentTab: Dispatch<SetStateAction<ContentTab>>;
};

export default function AdminContentToolbar({
  contentTab,
  onSave,
  saving,
  setContentTab,
}: AdminContentToolbarProps) {
  const t = siteTexts.admin;
  const tabs: ContentTab[] = [
    "hero",
    "about",
    "highlights",
    "products",
    "instagram",
  ];

  return (
    <div className="admin-content-toolbar">
      <div className="admin-subtabs">
        {tabs.map((tab) => (
          <Button
            key={`admin-content-tab-${tab}`}
            type="button"
            variant="pill"
            className={contentTab === tab ? "active" : ""}
            onClick={() => setContentTab(tab)}
          >
            {t.contentTabs[tab]}
          </Button>
        ))}
      </div>
      <Button type="button" variant="primary" onClick={onSave} disabled={saving}>
        {saving ? t.saving : t.saveChanges}
      </Button>
    </div>
  );
}
